/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentProps } from 'preact';
import { useCallback } from 'preact/hooks';
import { FormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';
import { InlineUserAssistance } from '../UNSAFE_UserAssistance';
import { dropdownStyles } from './themes/dropdownStyles.css';

type InlineUserAssistanceProps = Pick<
  ComponentProps<typeof InlineUserAssistance>,
  | 'assistiveText'
  | 'fieldLabel'
  | 'helpSourceLink'
  | 'helpSourceText'
  | 'id'
  | 'userAssistanceDensity'
>;

export function DropdownUserAssistance(props: InlineUserAssistanceProps) {
  // Prevent the focus from transferring when the user clicks on an empty/non-clickable area
  // of the user assistance
  const handleMouseDown = useCallback((event: MouseEvent) => {
    // Don't call preventDefault when the user clicks on the help source link, so that the
    // focus is allowed to transfer in that case.
    if ((event.target as Element)?.tagName !== 'A') {
      event.preventDefault();
    }
  }, []);

  return (
    <FormFieldContext.Provider value={{ isFocused: true }}>
      <div class={dropdownStyles.userAssistance} onMouseDown={handleMouseDown}>
        <InlineUserAssistance {...props} />
      </div>
    </FormFieldContext.Provider>
  );
}
